import styles from 'components/contactForm/progressBar/progressBar.module.css';

export const ProgressBar = ({ step }: { step: number }) => {
    return (
        <div className={styles.progressBar}>
            <div className={styles.progressBar__info}>
                <h4 className={styles.progressBar__title}>Question</h4>
                <div className={styles.progressBar__steps}>{step}/3</div>
            </div>
            <div className={styles.progressBar__percentage}>
                <div
                    style={{ width: `${(step / 3) * 100}%` }}
                    className={styles.progressBar__percentageInner}
                ></div>
            </div>
        </div>
    );
};
